export const TOWER_GAME_MODES = ['classic', 'advanced']

export const TOWER_DIFFICULTY_LEVELS = [
  { difficulty: 'easy', labelKey: 'EASY', columnsPerLevel: 4, minesPerLevel: 1 },
  { difficulty: 'medium', labelKey: 'MEDIUM', columnsPerLevel: 3, minesPerLevel: 1 },
  { difficulty: 'hard', labelKey: 'HARD', columnsPerLevel: 2, minesPerLevel: 1 },
  { difficulty: 'extreme', labelKey: 'EXTREME', columnsPerLevel: 3, minesPerLevel: 2 },
  { difficulty: 'nightmare', labelKey: 'NIGHTMARE', columnsPerLevel: 4, minesPerLevel: 3 }
]

export const CURRENCY_CODES = {
  GOLD_COIN: 'GC',
  ALIBABA_COIN: 'AC'
}

// rows are starting from 0 to 8
export const TOWER_GAME_ADVANCE_ROWS = {
  2: { multiplier: 2, odds: 0.02 },
  5: { multiplier: 5, odds: 0.05 },
  8: { multiplier: 10, odds: 0.1 }
}
